import { useState } from 'react';
import type { FixedParam } from '../types/parameters.types';
import { type EditValues, formatFixedClass, buildFixedUpdatedParam } from '../utils/paramsTableUtils';

const getEditValues = (param: FixedParam): EditValues => ({
	low: formatFixedClass(param, 'Baixo'),
	medium: formatFixedClass(param, 'Medio'),
	high: formatFixedClass(param, 'Alto'),
});

export const useFixedParamsEdit = (
	params: FixedParam[],
	onChange?: (params: FixedParam[]) => void
) => {
	const [editingCode, setEditingCode] = useState<string | null>(null);
	const [editValues, setEditValues] = useState<EditValues>({ low: '', medium: '', high: '' });

	const commitCurrent = (currentEditValues: EditValues) => {
		if (!editingCode || !onChange) return;
		const prev = params.find((p) => p.code === editingCode);
		if (!prev) return;
		const updated = buildFixedUpdatedParam(prev, currentEditValues);
		onChange(params.map((p) => (p.code === editingCode ? updated : p)));
	};

	const startEdit = (param: FixedParam) => {
		if (!onChange) return;
		if (editingCode && editingCode !== param.code) {
			commitCurrent(editValues);
		}
		setEditingCode(param.code);
		setEditValues(getEditValues(param));
	};

	const handleInputChange = (param: FixedParam, field: keyof EditValues, value: string) => {
		const newValues = { ...editValues, [field]: value };
		setEditValues(newValues);
		if (onChange) {
			const updated = buildFixedUpdatedParam(param, newValues);
			onChange(params.map((p) => (p.code === param.code ? updated : p)));
		}
	};

	return { editingCode, editValues, startEdit, handleInputChange };
};
